import React, {useState} from 'react';
import Image from 'next/image';
import classes from './RatePopup.module.scss'
import ratingIcon from '@/app/assets/images/icons/ratingIcon.svg';
import {useTranslation} from "react-i18next";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import {rate, verifyMeeting} from "@/app/actions/calendarActions";
import {notification} from "antd";
import Placeholder from "@/app/components/placeholder/Placeholder";


function RatePopup({setUnreadNotifications,closeModal,closeFirstModal,data}) {
    const {t} = useTranslation();

    const [hoverIndex, setHoverIndex] = useState(null);
    const [clickedIndex,setClickedIndex] = useState(null);
    const [loading,setLoading] = useState(false);
    const [api, contextHolder] = notification.useNotification();

    const openNotification = (type, placement, text) => {
        api[type]({
            message: `${type === 'error' ? t('notifications.error') : t('notifications.success')}`,
            description: text,
            placement,
        });
    };
    const handleMouseEnter = (index) => {
        setHoverIndex(index);
    };
    const handleMouseLeave = () => {
        setHoverIndex(null);
    };
    const handleClick = (index) => {
        setClickedIndex(index);
    };
    const handleSubmit = (skipClicked = false) => {
        if(!skipClicked) {
            setLoading(true)
            verifyMeeting(data.meeting_id).then((res) => {
                if(res === 200) {
                    rate({rating: clickedIndex + 1, id: data.mediator.id}).then((res) => {
                        if(res <= 299 && res >= 200) {
                            openNotification('success', 'bottomRight', t('notifications.successRate'))
                            setTimeout(() => {
                                setUnreadNotifications((prevNotifications) =>
                                    prevNotifications.filter(notification => notification.meeting_id !== data.meeting_id)
                                );
                                closeModal();
                                closeFirstModal();
                                setLoading(false);
                            },1000);
                        } else {
                            openNotification('error', 'bottomRight', t('notifications.serverError'))
                            setLoading(false);
                        }
                    }).catch(() => {
                        openNotification('error', 'bottomRight', t('notifications.serverError'))
                        setLoading(false);
                    })
                }else {
                    openNotification('error', 'bottomRight', t('notifications.serverError'))
                    setLoading(false);
                }
            }).catch((err) => {
                openNotification('error', 'bottomRight', t('notifications.serverError'))
                setLoading(false);
            })
        }else {
            setLoading(true);
            verifyMeeting(data.meeting_id).then((res) => {
                if(res === 200) {
                    setUnreadNotifications((prevNotifications) =>
                        prevNotifications.filter(notification => notification.meeting_id !== data.meeting_id)
                    );
                    closeModal();
                    closeFirstModal();
                    setLoading(false);
                }else {
                    openNotification('error', 'bottomRight', t('notifications.serverError'))
                    setLoading(false);
                }

            })
        }
    }

    return (
        <div className={classes.wrapper}>
            {contextHolder}
            {data.mediator.profile_photo ?  <Image width={84} height={84} className={classes.organizerImage} src={data.mediator.profile_photo} alt={'organizer image'}/> :
            <Placeholder name={data.mediator.name}
                         className={classes.placeholder}/>}
            <h3 className={classes.organizerName}>{data.mediator.name}</h3>
            <p className={classes.role}>Organizer</p>
            <div className={classes.organizerRating}>
                <Image src={ratingIcon} alt={'rating icon'}/>
                <span>{(Number(data.mediator.average_rating)).toFixed(2) === 'NaN' ? t('noRatings')
                    : (Number(data.mediator.average_rating)).toFixed(2)}</span>
            </div>
            <h2 className={classes.rateHeader}>{t('modal.rateText')} {data.mediator.name} ?</h2>
            <div className={classes.starsContainer}>
                {[...Array(5)].map((_, index) => (
                    <svg
                        key={index}
                        className={`${classes.star} ${hoverIndex !== null && hoverIndex >= index ? classes.hovered : ''} ${clickedIndex !== null && clickedIndex >= index ? classes.clicked : ''}`}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => handleClick(index)}
                xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <g clipPath="url(#clip0_2223_1178)">
                    <path d="M15.1125 13.4566L3.4158 15.1525L3.20864 15.1946C2.89503 15.2779 2.60913 15.4429 2.38014 15.6728C2.15115 15.9027 1.98728 16.1892 1.90525 16.5031C1.82322 16.8171 1.82599 17.1472 1.91325 17.4597C2.00052 17.7722 2.16917 18.056 2.40197 18.282L10.8756 26.5301L8.8773 38.181L8.85347 38.3826C8.83427 38.707 8.90162 39.0306 9.04863 39.3204C9.19563 39.6102 9.41701 39.8557 9.69009 40.0318C9.96316 40.2078 10.2781 40.3082 10.6027 40.3225C10.9274 40.3368 11.2499 40.2646 11.5375 40.1133L21.9985 34.6133L32.4356 40.1133L32.619 40.1976C32.9216 40.3168 33.2505 40.3534 33.5719 40.3035C33.8933 40.2537 34.1956 40.1192 34.4479 39.914C34.7002 39.7087 34.8933 39.44 35.0075 39.1355C35.1217 38.8309 35.1528 38.5015 35.0976 38.181L33.0975 26.5301L41.5748 18.2801L41.7178 18.1243C41.9221 17.8727 42.056 17.5715 42.106 17.2513C42.1559 16.9311 42.1201 16.6033 42.0021 16.3015C41.8842 15.9996 41.6883 15.7344 41.4345 15.5329C41.1807 15.3314 40.878 15.2008 40.5573 15.1543L28.8606 13.4566L23.632 2.85998C23.4807 2.55296 23.2465 2.29442 22.9558 2.11364C22.6652 1.93285 22.3297 1.83704 21.9875 1.83704C21.6452 1.83704 21.3098 1.93285 21.0191 2.11364C20.7285 2.29442 20.4943 2.55296 20.343 2.85998L15.1125 13.4566Z" fill="#E6F0FD"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_2223_1178">
                    <rect width="44" height="44" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>
                ))}
            </div>
            <RoundedButton type="primary"
                           className={classes.btn}
                           disabled={clickedIndex === null}
                           loading={loading}
                onClick={() => handleSubmit(false)}
            >
                {t('buttons.submit')}
            </RoundedButton>
            <p onClick={() => { handleSubmit(true) }} className={`${loading && classes.disabled} ${classes.skipBtn}`}>{t('buttons.skip')}</p>
        </div>
    );
}

export default RatePopup;